import NewPasswordContainer from './new-password-container';
import NewPasswordForm from './new-password-form';

export function NewPassword() {
  return (
    <NewPasswordContainer>
      <NewPasswordForm />
    </NewPasswordContainer>
  );
}
